import { Share2, Link as LinkIcon } from "lucide-react";
import { toast } from "sonner";

const SITE_NAME = "Nityavastra";

function getProductUrl(product) {
  const path = `/product/${product?.slug || product?.id || ""}`;

  if (typeof window === "undefined") {
    return path;
  }

  return new URL(path, window.location.origin).href;
}

export default function ShareProductButton({
  product,
  className = "",
  iconOnly = true,
}) {
  const handleShare = async (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (!product?.id && !product?.slug) {
      toast.error("Product link is unavailable");
      return;
    }

    const url = getProductUrl(product);
    const title = product.name || SITE_NAME;
    const price =
      product.price !== undefined && product.price !== null
        ? `₹${Number(product.price).toLocaleString("en-IN")}`
        : "";

    const text = price
      ? `${title} — ${price} | ${SITE_NAME}`
      : `${title} | ${SITE_NAME}`;

    if (typeof navigator !== "undefined" && navigator.share) {
      try {
        await navigator.share({
          title,
          text,
          url,
        });
        return;
      } catch (error) {
        // User cancelled the native share sheet.
        if (error?.name === "AbortError") {
          return;
        }
      }
    }

    try {
      if (navigator?.clipboard?.writeText) {
        await navigator.clipboard.writeText(url);
      } else {
        const textarea = document.createElement("textarea");
        textarea.value = url;
        textarea.setAttribute("readonly", "");
        textarea.style.position = "fixed";
        textarea.style.opacity = "0";
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        textarea.remove();
      }

      toast.success("Product link copied");
    } catch {
      toast.error("Unable to copy product link");
    }
  };

  return (
    <button
      type="button"
      onClick={handleShare}
      aria-label={`Share ${product?.name || "product"}`}
      title="Share product"
      className={className}
    >
      <Share2 className="h-4 w-4" />
      {!iconOnly && (
        <span className="flex items-center gap-1.5">
          <LinkIcon className="h-3.5 w-3.5" />
          Share
        </span>
      )}
    </button>
  );
}
